module.exports = __webpack_public_path__ + "img/demand.1d128d13.svg";